<template>
  <vs-popup
    :title="`Insert venue ${activeVenue.name} in Marcom`"
    @close="handlePopupClose"
    :active.sync="showThisPopup"
    class="add-venue-popup"
  >
    <div class="text-center p-16" v-if="isLoadingLocations">
      <p class="opacity-60">Getting started</p>
      <span class="flex h-12 w-12 mx-auto mt-5">
        <span
          class="
            animate-ping
            absolute
            inline-flex
            h-12
            w-12
            rounded-full
            bg-primary
            opacity-75
          "
        ></span>
        <span
          class="relative inline-flex rounded-full h-12 w-12 bg-primary"
        ></span>
      </span>
    </div>
    <vs-row v-if="!isLoadingLocations" vs-w="12">
      <vs-col vs-w="12">
        <h4>First time setup</h4>

        <vs-row vs-w="12">
          <vs-col vs-w="12">
            <vs-input
              label="Name of first setup"
              class="inputx"
              placeholder="Setup name"
              v-model="setupName"
            />
            <p class="mb-1">
              <small>Name of the setup. Example: 'Regular week'</small>
            </p>
          </vs-col>
        </vs-row>

        <vs-row vs-w="12" class="mt-2">
          <vs-col vs-w="12">
            <vs-select v-model="selectedLocation" label="Location" placeholder="Select Location">
              <vs-select-item
                :key="'location-' + index"
                :value="item"
                :text="item.name"
                v-for="(item, index) in locations"
              />
            </vs-select>
            <p class="mb-1" style="max-width: 48rem; line-height: 1.4">
              <small
                >You need to select a location for this venue, for easy
                filtering for the guest.</small
              >
            </p>
          </vs-col>
        </vs-row>

        <vs-row vs-w="12" class="mt-2">
          <vs-col vs-w="12">
            <vs-input
              class="inputx"
              label="Url short name"
              placeholder="Input shortname"
              v-model="shortName"
            />
            <p class="mb-1" style="max-width: 48rem; line-height: 1.4">
              <small
                >We need a short-name for linking to the booking-page. The
                short-name must be unique. Only lower case letters, underscore
                '_' and no spaces. Example 'heidies_cph'</small
              >
            </p>
          </vs-col>
        </vs-row>

        <vs-row vs-w="12" class="mt-2">
          <vs-col vs-w="12">
            <vs-select
              v-model="selectedCountryCode"
              label="Country Code"
              @change="handleCountryCodeSelected"
              placeholder="Select Country"
            >
              <vs-select-item
                :key="'currencyCountryCode-' + index"
                :value="item"
                :text="`${item.name} (${item.code})`"
                v-for="(item, index) in countryCodes"
              />
            </vs-select>
            <p class="mb-1" style="max-width: 48rem; line-height: 1.4">
              <small
                >You need to select a country code, which in turn selects
                currency for this venue. This will affect products and policies
                of this venue.</small
              >
            </p>
          </vs-col>
        </vs-row>

        <vs-row vs-w="12" class="mt-2">
          <!-- <vs-col vs-w="12"> -->
            <vs-select class="mr-2"
              v-model="selectedTimeZoneArea"
              label="Time Zone Area/Type"
              @change="handleTimeZoneAreaSelected"
              placeholder="Select Country first"
            >
              <vs-select-item
                :key="'timeZoneArea-' + index"
                :value="item"
                :text="item.area"
                v-for="(item, index) in timeZoneAreas"
              />
            </vs-select>

            <vs-select v-if="selectedTimeZoneArea"
              v-model="selectedTimeZoneCity"
              label="Time Zone City/Subtype"
            >
              <vs-select-item
                :key="'timeZoneCity-' + index"
                :value="item"
                :text="item"
                v-for="(item, index) in timeZoneCities"
              />
            </vs-select>
          <!-- </vs-col> -->
        </vs-row>
        <vs-row vs-w="12">
          <p class="mb-1" style="max-width: 48rem; line-height: 1.4">
              <small
                >You need to select a time zone area/type and 'city/subtype',
                so time values of this venue and policies can be calculated correctly.</small
              >
            </p>
        </vs-row>

      </vs-col>
    </vs-row>

    <vs-row vs-w="12" vs-justify="flex-end">
      <vs-button
        color="primary"
        :disabled="!validForm"
        @click="handleSaveVenueClick"
        >Save Venue</vs-button
      >
    </vs-row>
  </vs-popup>
</template>

<script>
import { mapGetters } from "vuex";
import * as _ from "lodash";
import moment from "moment";
import "moment-timezone";
import { ACTIONS as VENUE_ACTIONS } from "@/store/modules/marcom/marcom";

export default {
  components: {},
  data() {
    return {
      shortName: "",
      setupName: "",
      selectedLocation: null,
      selectedCountryCode: undefined,
      showThisPopup: false,
      timeZoneAreas: [],
      timeZoneCities: [],
      selectedTimeZoneArea: undefined,
      selectedTimeZoneCity: undefined,
    };
  },
  async created() {
    await this.$store.dispatch("venues/getGeneralInfo");

    this.shortName = this.defaultShortName();
  },
  computed: {
    ...mapGetters({
      activeVenueGeneralInfo: "venues/generalInfo",
      activeVenue: "venues/activeVenue",
      locations: "marcom/locations",
      isLoadingLocations: "marcom/isLoadingLocations",
      countryCodes: "marcom/countryCodes",
    }),
    validForm() {
      return this.shortName !== "" && this.setupName !== "" && this.selectedLocation &&
        this.selectedCountryCode && this.selectedTimeZoneArea && this.selectedTimeZoneCity;
    },
  },
  methods: {
    defaultShortName() {
      if (this.activeVenueGeneralInfo && this.activeVenueGeneralInfo.tags) {
        let tag = this.activeVenueGeneralInfo.tags.find((t) =>
          _.startsWith(t, "venue:")
        );
        if (tag) {
          let index = tag.indexOf(":");
          return tag.substring(index + 1);
        }
      }
      return "";
    },
    createTimeZoneAreas(timeZonesByCountryCodeFromServer) {
      const groupedTimeZoneNames = [];
      timeZonesByCountryCodeFromServer.forEach(tz => {
        //skip those that do not exist in moment
        if(!this.timeZoneExistsInMoment(tz)) return;

        let tzSplit = _.split(tz.olsonTimeZone, '/');
        //skip those with no city
        if(tzSplit.length < 2) return;

        let areaName = tzSplit[0];
        let cityName = tzSplit.slice(1).join('/');
        let area = groupedTimeZoneNames.find(g => g.area === areaName);
        if(!area) {
          area = { area: areaName, cities: []};
          groupedTimeZoneNames.push(area);
        }
        area.cities.push(cityName);
      });
      return groupedTimeZoneNames;
    },
    timeZoneExistsInMoment(timeZoneFromServer) {
      const timeZonesByCountryCodeFromMoment = moment.tz.zonesForCountry(this.selectedCountryCode.code);
      if(timeZonesByCountryCodeFromMoment.includes(timeZoneFromServer.olsonTimeZone))
        return true;

      //then try in aliases
      const intersection = _.intersection(timeZoneFromServer.aliases, timeZonesByCountryCodeFromMoment);
      return intersection.length > 0;
    },
    show() {
      this.showThisPopup = true;
    },
    async handleCountryCodeSelected() {
      try {
        this.$vs.loading();

        const timeZonesByCountryCodeFromServer = await this.$store.dispatch("marcom/" + VENUE_ACTIONS.GetTimeZonesByCountryCode,
          this.selectedCountryCode);

        this.timeZoneAreas = this.createTimeZoneAreas(timeZonesByCountryCodeFromServer);
        if(this.timeZoneAreas.length > 0) {
          this.selectedTimeZoneArea = this.timeZoneAreas[0];
        }
        else {
          this.selectedTimeZoneArea = undefined;
        }
      }
      catch(err){
        console.error(err);

        this.$vs.notify({
          color: "danger",
          title: "Failed getting timezones",
          text: "Could not get time zone for the selected country",
        });
      }
      finally{
        this.$vs.loading.close();
      }
    },
    handleTimeZoneAreaSelected() {
      this.timeZoneCities = this.selectedTimeZoneArea.cities;
      if(this.timeZoneCities.length > 0) {
        this.selectedTimeZoneCity = this.timeZoneCities[0];
      }
      else {
        this.selectedTimeZoneCity = undefined;
      }
    },
    async handleSaveVenueClick() {
      try {
        this.$vs.loading();

        //Call service
        var venueCommand = {
          locationId: this.selectedLocation.id,
          name: this.activeVenue.name,
          shortName: this.shortName,
          address: this.activeVenue.address,
          venuePortalId: this.activeVenue.venueId,
          setupName: this.setupName,
          image: this.activeVenue.imageUrl,
          iso3166CountryCode: this.selectedCountryCode.code,
          timeZoneCode: `${this.selectedTimeZoneArea.area}/${this.selectedTimeZoneCity}`,
        };
        var result = await this.$store.dispatch(
          "marcom/" + VENUE_ACTIONS.AddVenue,
          venueCommand
        );

        this.$vs.notify({
          color: "success",
          title: "Setup added",
          text: "Your setup was added",
        });

        this.handlePopupClose();
      } catch (err) {
        console.error(err);

        this.$vs.notify({
          color: "danger",
          title: "Venue add failed",
          text: "The venue could not be saved",
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    handlePopupClose() {
      this.showThisPopup = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.add-venue-popup::v-deep .vs-popup {
  width: 1080px;

  .vs-popup--content {


    .vs-tabs--content {
      max-height: calc(100vh - 225px);
      overflow: auto;
      margin-top: 10px;
      margin-bottom: 10px;
    }
  }
}
</style>
